/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppEmbeddedSignupDisconnectWhatsAppPathParams,
	WhatsAppEmbeddedSignupDisconnectWhatsAppResponse,
} from '../types/WhatsAppEmbeddedSignupDisconnectWhatsApp'

/**
 * POST /organisations/:organisationId/whatsapp-account/disconnect
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::disconnectWhatsApp
 */
export async function whatsAppEmbeddedSignupDisconnectWhatsApp(
	organisationId: WhatsAppEmbeddedSignupDisconnectWhatsAppPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppEmbeddedSignupDisconnectWhatsAppResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/whatsapp-account/disconnect`, undefined, config)
}
